import { GenericBackendResponse } from '../../genericBackendResponse';

export interface PayfitCompanyIdDto {
	access_token: string;
	company_id: string;
}

export interface PayfitEmail {
	email: string;
	type: string;
}

export interface PayfitContract {
	id: string;
	startDate: string;
	endDate: string | null;
	status: 'ACTIVE' | 'ARCHIVED';
}

export interface PayfitCollaborator {
	id: string;
	matricule: string | null;
	firstName: string;
	lastName: string;
	secondLastName: string | null;
	birthName: string | null;
	birthDate: string | null;
	terminationDate: string | null;
	gender: 'male' | 'female' | null;
	emails: PayfitEmail[];
	contracts: PayfitContract[];
}

export interface PayfitCollaboratorsMeta {
	nextPageToken: string | null;
	count: number;
}

export interface PayfitCollaboratorsResponse {
	collaborators: PayfitCollaborator[];
	meta: PayfitCollaboratorsMeta;
}

export type ListCollaboratorsResponse = GenericBackendResponse<PayfitCollaboratorsResponse>;

const listCollaborators = async (
	token: string,
	access_token: string,
	company_id: string
): Promise<ListCollaboratorsResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/payfit/collaborators`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({ token: access_token, company_id })
		}
	);
	return response.json();
};

export default listCollaborators;
